import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { BodyWrapper, Header, Loader, MainWrapper } from '@components';
import {
  businessQuery,
  datamodelItemMutation,
  datamodelsQuery,
} from '@queries';
import { ChevronRightIcon } from '@svgs';

import { ContentDatabaseItemForm } from '../components/ContentDatabaseItemForm/ContentDatabaseItemForm.jsx';
import { ProjectBreadcrumbs } from '../components/ProjectBreadcrumbs/ProjectBreadcrumbs.jsx';
import ProjectSidebar from '../components/ProjectSidebar/ProjectSidebar.jsx';

export const AddContentDatabaseItem = () => {
  const { t, i18n } = useTranslation();
  const { businessID } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // get business
  const { data: businessData, isPending: businessIsPending } = useQuery(
    businessQuery(businessID),
  );

  // get datamodels
  const { data: datamodelsData, isPending: datamodelsIsPending } = useQuery(
    datamodelsQuery({
      datamodel_type: 'datamodel_item',
      order_by: 'name',
    }),
  );

  // save datamodel
  const mutation = useMutation(
    datamodelItemMutation(null, {
      onSuccess: (data) => {
        // invalidate list views so they are re-fetched
        queryClient.invalidateQueries({
          queryKey: ['datamodels/items', 'list'],
        });
        // navigate to the edit view
        navigate(`/dashboard/projects/${businessID}/contentitems/${data.id}`);
      },
    }),
  );

  return (
    <>
      <Header />
      <BodyWrapper>
        <ProjectSidebar businessID={businessID} businessData={businessData} />
        <MainWrapper>
          <ProjectBreadcrumbs businessData={businessData}>
            <li className="sb-flex">
              <Link to={`/dashboard/projects/${businessID}/contentitems`}>
                Content database
              </Link>
              <ChevronRightIcon />
            </li>
            <li className="sb-flex">Add</li>
          </ProjectBreadcrumbs>
          <div className="sb-manage-content">
            {datamodelsIsPending && (
              <>
                <h1>Add</h1>
                <Loader className="sb-loader sb-loader-large" />
              </>
            )}
            {!datamodelsIsPending && (
              <>
                <h1>Add</h1>
                <ContentDatabaseItemForm
                  disabled={mutation.isPending}
                  mutation={mutation}
                  datamodelsData={datamodelsData}
                />
              </>
            )}
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
